import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { ItestListItem } from '../../../interfaces/test-list-item';
import { SessionStorageService, TableKeyData } from '@ispm/shared/services/session-storage.service';

@Component({
  selector: 'gen-test-list',
  templateUrl: './test-list.component.html',
  styleUrls: ['./test-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestListComponent {

  public testsFormalize: ItestListItem[] = [];

  public testListToDisplay: ItestListItem[] = [];

  public testColumnsToDisplay: Array<any> = [
    { field: 'testType' },
    { field: 'testNumber' },
    { field: 'revision' },
    { field: 'date' },
    { field: 'status' },
    { field: 'MRN'}
  ];

  public maxNumberOfDisplayedRows: number = 10;

  @Input() currentRevisionId: string;
  @Input() needDataFormalization: boolean = true;

  @Output() testSelectEmit: EventEmitter<any> = new EventEmitter();

  @Input() set tests(tests) {
    if (!tests) {
      return;
    }
    this.testsFormalize = [];

    // tests resourceType can be a WorkflowRequest or a UIPractWorkListRow. There is a different structure for each one
    const workflowResource: boolean = tests && tests.length > 0 && tests[0].resourceType === 'WorkflowRequest' ? true : false;
    if (!workflowResource) {
      tests.forEach((test) => this.fillTestsFormalize(test));
    }
    else {
      tests.forEach((test) => {
        this.testsFormalize.push(
          this.generateNewRow(test.id, test.testNumber, test.name, test.revisions[test.revisions.length - 1])
        );
      });
    }
    this.testListToDisplay = this.testsFormalize;
  }

  constructor(
    private sessionStorageService: SessionStorageService
  ) {
  }

  private fillTestsFormalize(test) {
    const keys = [
      'revName',
      'revDatetime',
      'TestNumber',
      'testName',
      'status',
      'revisionId',
      'workflowRequestId',
      'MRN',
    ];
    const data: TableKeyData = this.sessionStorageService.getTableKeyDataFromCurrentWorkList(test, keys);
    const revision = {
      name: data.revName,
      id: data.revisionId,
      datetime: data.revDatetime,
      status: data.status,
      MRN: data.MRN,
    };

    this.testsFormalize.push(
      this.generateNewRow(data.workflowRequestId, data.TestNumber, data.testName, revision)
    );
  }

  generateNewRow(id: string, testNumber: string, testType: string, revision: any): ItestListItem {
    return {
      id: id,
      testType: testType,
      testNumber: testNumber,
      revision: revision.name,
      revisionId: revision.id,
      date: new Date(revision.datetime),
      status: revision.status,
      MRN: revision.MRN,
      numberTooltip: false,
    };
  }

  openTest(test) {
    if (test.revisionId !== this.currentRevisionId) {
      this.testSelectEmit.emit({
        testType: test.testType,
        testId: test.id,
        revisionId: test.revisionId,
        status: test.status
      });
    }
  }

  getRowClasses(test) {
    const currentRow = 'current Auto_Test_List_Item';
    const defaultRow = 'Auto_Test_List_Item';

    if (!test) {
      let a = test;
    }
    return test && test.revisionId === this.currentRevisionId ? currentRow : defaultRow;
  }
}
